import styled, { css } from "styled-components";

export const Body = styled.div`
  height: 100%;
`;

export const ImportErrorLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
  padding: 24px;
  text-align: center;
`;

export const ImportErrorTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

export const ImportErrorMessage = styled.div`
  max-width: 420px;
  color: var(--sui-gray-600, #6b7280);
`;

export const ApplicationButtonLayout = styled.div`
  position: absolute;
  top: -8px;
  right: 300px;
`;

export const UpdateExistingRecordsButtonLayout = styled.div`
  position: absolute;
  top: -8px;
  right: 75px;
`;

export const CloseHide = styled.div`
  position: absolute;
  top: 10px;
  right: 0px;
  height: 30px;
  width: 60px;
  background-color: white;
`;

export const CloseHideWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 60px;
  width: 60px;
  background-color: transparent;
`;

export const LocalCssVariablesWrapper = styled.div`
  ${({ theme }) => css`
    --solution-primary-color: ${theme.primaryColor};
    --solution-secondary-color: ${theme.secondaryColor};
    --solution-hover-color: ${theme.hoverColor};
    --solution-highlight-color: ${theme.highlightColor};
    --solution-primary-color-rgb: ${theme.primaryColorRGB};
    --solution-secondary-color-rgb: ${theme.secondaryColorRGB};
    --solution-hover-color-rgb: ${theme.hoverColorRGB};
    --solution-highlight-color-rgb: ${theme.highlightColorRGB};
  `}
`;
